module.exports = __webpack_public_path__ + "img/2026-10-11c_4.ab14136f.jpg";